import { useMemo } from "react";
import secondaryComponents from "../..";
import { useActivityLogRecords } from "./useActivityLogRecords";
import styles from "./styles.module.scss";

export const ActivityLogRecords = ({ activityLogRecords }) => {
  const newActivityLogRecords = useMemo(() => {
    return Object.entries(activityLogRecords).map(([key, value]) => ({
      key,
      ...value,
    }));
  });
  const { instance } = useActivityLogRecords({
    activityLogRecords: newActivityLogRecords,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
        classNames={`${styles.tableSection}`}
      >
        <div className="text-center my-5">
          <h4 className="">No Data Available</h4>
        </div>
      </secondaryComponents.TableHelper>
    </>
  );
};
